import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { RedtextRoutingModule } from './redtext-routing.module';
import { SharedModule } from '../../shared/shared.module';
import { RedtextPageComponent } from './pages/redtext-page/redtext-page.component';
import { RedtextViewComponent } from './components/redtext-view/redtext-view.component';
import { MatIconModule } from '@angular/material/icon';
import { MatRippleModule } from '@angular/material/core';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MarkdownModule } from 'ngx-markdown';
import { SafePipe } from 'safe-pipe';


@NgModule({
  declarations: [RedtextPageComponent, RedtextViewComponent],
  imports: [
    CommonModule,
    SharedModule,
    RedtextRoutingModule,
    MatIconModule,
    MatRippleModule,
    MatProgressSpinnerModule,
    MarkdownModule,
    SafePipe
  ]
})
export class RedtextModule {
}
